export default __webpack_public_path__ + "static/media/NIAS0360.34I-34816_-19519_0.9f36728d.jpg";